import React, { Component } from 'react';

import Icon from 'components/icons';
import { I18n } from 'components/translate';
import { MembershipEventService } from 'modules/membershipEvent';
import { EVENTS } from 'modules/membershipEvent/constants';
import PropTypes from 'prop-types';

import './AdditionalContentTip.scss';

export default class AdditionalContentTip extends Component {
  static propTypes = {
    onEnable: PropTypes.func
  };

  state = {
    closed: false
  };

  onClose = () => this.setState({ closed: true });

  onEnable = () => {
    this.onClose();
    this.props.onEnable && this.props.onEnable();
  };

  onDisable = () =>
    MembershipEventService.dismissEvent(EVENTS.ADDITIONAL_CONTENT_TIP);

  render() {
    const { closed } = this.state;

    return (
      !closed && (
        <div className="notification__add__extra__content">
          <div className="notification__add__extra__content__title">
            <span className="notification__add__extra__content__title__icon">
              <Icon prefix="fal" iconName="lightbulb" />
            </span>
            <span className="text">
              <I18n label="content_list.club_tips" />
            </span>
          </div>

          <div className="notification__add__extra__content__text">
            <I18n label="content_list.alert_text" />
          </div>

          <div className="notification__add__extra__content__actions">
            <button
              className="hot-button hot-button--primary hot-button--block"
              onClick={this.onEnable}
            >
              <I18n label="member.content.start_now" />
            </button>

            <button
              className="hot-button hot-button--tertiary hot-button--block"
              onClick={this.onDisable}
            >
              <I18n label="content_list.dismiss_alert" />
            </button>
          </div>

          <button
            className="btn__notification btn__notification__close"
            onClick={this.onClose}
          >
            <span className="btn__notification__text" />
          </button>
        </div>
      )
    );
  }
}
